module.exports = __webpack_public_path__ + "img/right-drawn-arrow.16d357fc.svg";